import Vue from 'vue'
import Router from 'vue-router'
import { constantRouterMap, asyncPersonRouterMap,asyncCompanyRouterMap } from './router.config'

// hack router push callback
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: constantRouterMap
})

export default router

// 初始化动态路由
export function resetRouter() {
  router.matcher = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: constantRouterMap
}).matcher  // reset router
}



